module.exports = __webpack_public_path__ + "static/media/watch.8763daf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/Icons/assets/svgs/watch.svg
// module id = ./src/assets/Mozilla/DesignTokens/Icons/assets/svgs/watch.svg
// module chunks = 0